/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1MylibraryTeachersCandidates200,
  GetApiV1MylibraryTeachersCandidates401,
  GetApiV1MylibraryTeachersCandidates500,
  GetApiV1MylibraryTeachersCandidatesQueryParams,
  GetApiV1MylibraryTeachersCandidatesQueryResponse,
} from "../../types/myLibraryCandidatosController/GetApiV1MylibraryTeachersCandidates.ts";
import { myLibraryTeacherCandidateViewModelSchema } from "../myLibraryTeacherCandidateViewModelSchema.ts";

export const getApiV1MylibraryTeachersCandidatesQueryParamsSchema = z
  .object({
    Filter: z.optional(
      z
        .string()
        .describe(
          "Texto de busca aplicado ao nome ou ao e-mail do professor. A comparação ignora maiúsculas e minúsculas. Opcional.",
        ),
    ),
  })
  .optional() as unknown as ToZod<GetApiV1MylibraryTeachersCandidatesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1MylibraryTeachersCandidates200Schema = z.array(
  z.lazy(() => myLibraryTeacherCandidateViewModelSchema),
) as unknown as ToZod<GetApiV1MylibraryTeachersCandidates200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1MylibraryTeachersCandidates401Schema =
  z.any() as unknown as ToZod<GetApiV1MylibraryTeachersCandidates401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1MylibraryTeachersCandidates500Schema =
  z.any() as unknown as ToZod<GetApiV1MylibraryTeachersCandidates500>;

export const getApiV1MylibraryTeachersCandidatesQueryResponseSchema = z.lazy(
  () => getApiV1MylibraryTeachersCandidates200Schema,
) as unknown as ToZod<GetApiV1MylibraryTeachersCandidatesQueryResponse>;
